import React from 'react';
import ProductDetails from './ProductDetails';
import ProductPackaging from './ProductPackaging';

const ProductSteps = (mode: string) => [
  { label: 'Termék adatai', component: <ProductDetails mode={mode} /> },
  { label: 'Termék kiszerelései', component: <ProductPackaging mode={mode} /> },
];

export default ProductSteps;